export default "__VITE_PUBLIC_ASSET__72ef3b07__"